import React from 'react';
import { capitalizeFirstLetter } from 'formatters';
import { green } from '@mui/material/colors';
import { Box, Stack, Typography } from '@mui/material';

import { ReportsListingViewModel } from '../../../types';

interface Props {
  row: ReportsListingViewModel;
}

export const CustomerCell = ({ row }: Props) => {
  return (
    <Stack width="100%" gap="0.1rem">
      <Typography>{row.customerName}</Typography>

      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography
          variant={row.customerType === 'INDIVIDUAL' ? 'body1' : 'caption'}
          color={row.customerType === 'INDIVIDUAL' ? 'textPrimary' : 'textSecondary'}
        >
          {row.contact}
        </Typography>

        {row.customerType && (
          <Box sx={{ padding: '0 0.2rem', backgroundColor: green[200], borderRadius: '0.4rem', width: 'fit-content' }}>
            <Typography variant="caption">{capitalizeFirstLetter(row.customerType)}</Typography>
          </Box>
        )}
      </Stack>
    </Stack>
  );
};
